import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('edit_profile'),
    buttonSaveText: defineMessage('save'),
    buttonSaveTitle: defineMessage('save_profile_changes'),
    messageProfileSaved: defineMessage('your_profile_was_saved'),
    tabGeneral: defineMessage('general'),
    tabNotifications: defineMessage('notifications'),
    tabSecurity: defineMessage('security'),
    tabActiveSessions: defineMessage('active_sessions'),
};
